import { parseEntityId } from "./id-parser";
import { PhotoVariation } from "./photo-variation";
export const globalFilesEntityId = parseEntityId("1DA4F4F3-760C-4D12-AAAA-563CD02A1ECF");
export var FileManagementLevel;
(function (FileManagementLevel) {
    FileManagementLevel["Tenant"] = "Tenant";
    FileManagementLevel["System"] = "System";
})(FileManagementLevel || (FileManagementLevel = {}));
export class File {
    constructor() {
        this.entityId = null;
        this.tenantId = null;
        this.description = "";
        this.originalFilename = "";
        this.mimeType = "";
        this.storagePath = "";
        this.isSlideShowPhoto = false;
        this.slideShowOrder = 0;
        this.variations = [];
        this.createdAt = new Date();
        this.createdBy = null;
        this.updatedAt = new Date();
        this.updatedBy = null;
        this.deleted = false;
        this.id = null;
        this.byteLength = null;
        this.shareWithClient = false;
        this.shareWithCommunity = false;
        this.shareWithReferral = false;
        this.hasSignatureTemplate = false;
        this.isGlobal = false;
        this.managementLevel = FileManagementLevel.Tenant;
    }
    static load(source) {
        const loaded = new File();
        if (!source) {
            return loaded;
        }
        loaded.entityId = source.entityId;
        loaded.tenantId = source.tenantId;
        loaded.description = source.description;
        loaded.originalFilename = source.originalFilename;
        loaded.mimeType = source.mimeType;
        loaded.storagePath = source.storagePath;
        loaded.isSlideShowPhoto = source.isSlideShowPhoto;
        loaded.slideShowOrder = source.slideShowOrder;
        loaded.variations = (source.variations || []).map((v) => PhotoVariation.load(v));
        loaded.createdAt = source.createdAt ? new Date(source.createdAt) : new Date();
        loaded.createdBy = source.createdBy;
        loaded.updatedAt = source.updatedAt ? new Date(source.updatedAt) : new Date();
        loaded.updatedBy = source.updatedBy;
        loaded.deleted = source.deleted;
        loaded.id = source.id;
        loaded.byteLength = source.byteLength;
        loaded.shareWithClient = source.shareWithClient;
        loaded.shareWithCommunity = source.shareWithCommunity;
        loaded.shareWithReferral = source.shareWithReferral;
        loaded.hasSignatureTemplate = source.hasSignatureTemplate;
        loaded.isGlobal = source.isGlobal;
        loaded.managementLevel = source.managementLevel;
        return loaded;
    }
}
export const formatFileSize = (byteLength) => {
    if (typeof byteLength === "number") {
        if (byteLength === 1) {
            return "1 byte";
        }
        if (byteLength < 1024) {
            return `${byteLength} bytes`;
        }
        const roundedKB = Math.round(byteLength / 1024);
        if (roundedKB < 1024) {
            return `${roundedKB} KB`;
        }
        const roundedMB = Math.round((byteLength / 1024 / 1024) * 10) / 10;
        if (roundedMB < 1024) {
            return `${roundedMB} MB`;
        }
        const roundedGB = Math.round((byteLength / 1024 / 1024 / 1024) * 10) / 10;
        return `${roundedGB} GB`;
    }
    return "";
};
export const isPdf = (mimeType) => {
    return mimeType === "application/pdf";
};
export const isFilePreviewable = (file) => {
    return isPdf(file?.mimeType);
};
//# sourceMappingURL=file.js.map